import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,
  MenuItem,
} from "@mui/material";
import useAdd from "../../api/useAdd";
import useFetchObjects from "../../api/useFetchObjects";
import { useTranslation } from "react-i18next";

const Add = ({ open, onClose, token }) => {
  const { t } = useTranslation();
  const { handleAdd, loading, resetForm } = useAdd("shop/categories", token);
  const { data: shopsData, loading: shopLoading } = useFetchObjects(
    ["shop"],
    "shop/shop",
    token
  );

  const shops = shopsData?.results || [];

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedShop, setSelectedShop] = useState("");

  useEffect(() => {
    if (!shopLoading && shops && shops.length === 1) {
      setSelectedShop(shops[0].id);
    }
  }, [shopLoading, shops]);

  const handleSubmit = () => {
    const formData = {
      name: name.trim(),
      description,
      shop: selectedShop,
    };
    handleAdd(formData);
  };

  useEffect(() => {
    if (resetForm) {
      setName("");
      setDescription("");
      if (shops && shops.length === 1) {
        setSelectedShop(shops[0].id);
      } else {
        setSelectedShop("");
      }
      onClose();
    }
  }, [resetForm, onClose, shops]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("category.addCategory")}</DialogTitle>
      <DialogContent>
        <Box component="form" noValidate sx={{ mt: 1 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t("category.categoryName")}
            type="text"
            fullWidth
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <TextField
            margin="dense"
            label={t("category.description")}
            type="text"
            fullWidth
            multiline
            rows={4}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
          <TextField
            select
            margin="dense"
            label={t("category.shop")}
            fullWidth
            required
            value={selectedShop}
            onChange={(e) => setSelectedShop(e.target.value)}
          >
            {shopLoading ? (
              <MenuItem value="">
                <CircularProgress size={20} />
              </MenuItem>
            ) : (
              shops &&
              shops.map((shop) => (
                <MenuItem key={shop.id} value={shop.id}>
                  {shop.name}
                </MenuItem>
              ))
            )}
          </TextField>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="secondary" disabled={loading}>
          {t("category.cancel")}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={loading || !name.trim() || !selectedShop}
          sx={{ minWidth: 100 }}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : (
            t("category.submit")
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Add;
